import { keepPreviousData, type QueryOptions, useQueries } from '@tanstack/react-query';

import {
    type ApiResult,
    apiReturnResults,
    type BaseParams,
    type EmojiIdSearchResult,
    Emojis,
    type SearchQuery,
    type SearchResponse,
} from '@app/client';

const callSearchEmoji = (params: BaseParams<SearchQuery>) =>
    apiReturnResults<SearchResponse>(Emojis.Emoji.search, params);

// TODO: Move this hook.
export function useGetEmojiDetails(yatList: string[], disabled = false) {
    const getOptions = (emojiID) =>
        ({
            queryKey: ['emoji-search', emojiID],
            queryFn: ({ signal }) =>
                callSearchEmoji({ settings: { signal }, query: { emoji_id: emojiID } }) as Promise<
                    ApiResult<SearchResponse>
                >,
            enabled: Boolean(emojiID?.length) && !disabled,
            placeholderData: keepPreviousData,
            retry: true,
        }) as QueryOptions;

    const listResponse = useQueries({
        queries: yatList.map((yat) => ({
            queryKey: ['emojiDetails', yat],
            retry: false,
            queryFn: () => {
                const options = getOptions(yat);
                return {
                    ...options,
                    select: (r) => {
                        if (r.ok && r.value.result) {
                            return r.value.result;
                        }
                    },
                };
            },
        })),
    });

    const yatListRes: EmojiIdSearchResult[] = [];
    listResponse.forEach((r) => {
        const response = r?.data as unknown as SearchResponse['result'];
        if (response) {
            yatListRes.push(response);
        }
    });

    return yatListRes?.length ? yatListRes : [];
}
